export default "/images/Canine_full.svg?f95bd1ccb179448001341831c5a740e6";